import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { getOrganizations,  addOrganizationStaff, getOrgBranches, getOrgDepts, getOrgJobRoles } from "../../utils/helper";
import { alertSuccess, alertError } from "../../utils/alerts";
import { months } from "../../utils/dataFile";

const INIT_STATE = {
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    job_role: "",
    department : "",
    gender:"",
    branch: "",
    organization:"",
    staff_id: "",
    hire_date: "",
    hire_month: "",
    hire_year: "",
};

export default function OutsourcingEmployeeAdd() {
    const [state, setState] = useState(INIT_STATE);
    const [orgs, setOrgs] = useState(null);
    const [branches, setBranches] = useState(null);
    const [roles, setRoles] = useState(null);
    const [depts, setDepts] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        e.persist();
        setState((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    }

    useEffect(() => {
        getOrganizations()
            .then((res) => {
                setOrgs(res.data.data);
            })
            .catch((err) => {
                console.log(err.response.data.error)
            });
    }, []);

    useEffect(() => {
        if(state && state.organization){
            getOrgBranches(state.organization)
            .then((res) => {
                setBranches(res.data.data);
            })
            .catch((err) => {
                console.log(err.response.data.error)
            });
        }
    }, [state]);

    useEffect(() => {
        if(state && state.organization){
            getOrgJobRoles(state.organization)
            .then((res) => {
                setRoles(res.data.data);
            })
            .catch((err) => {
                console.log(err.response.data.error)
            });
        }
    }, [state]);

    
    useEffect(() => {
        if(state && state.organization){
            getOrgDepts(state.organization)
            .then((res) => {
                setDepts(res.data.data);
            })
            .catch((err) => {
                console.log(err.response.data.error)
            });
        }
    }, [state]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const data = { ...state, type: "outsourced", id: state.organization };

        if(data.id && data.first_name && data.last_name && data.email && data.phone && data.job_role && data.branch 
            && data.department && data.hire_date && data.hire_year && data.hire_month){
            setLoading(true);
            addOrganizationStaff(data)
            .then((res) => {
                if(res.data.success){
                    alertSuccess(res.data.message)
                } else {
                    alertError(res.data.message)
                }
                setLoading(false);
            })
            .catch((err) => {
                alertError(err.response?.data?.error);
                setLoading(false);
            });
        }
    };
    
    return (
        <>
            <h1 className="dash-title"><Link to="/outsourcing/employees" style={{color: '#454545'}}><i className="fa fa-arrow-left"></i> Go Back</Link></h1>

            <div className="row dash-row">
                <div className="col-md-12 col-sm-12 col-12">
                    <div className="card spur-card" style={{marginTop: 5}}>
                        <div className="card-header">
                            <div className="spur-card-title">Add New Outsourced Employee</div>
                        </div>
                        <div className="card-body">
                            <form method="post" encType="multipart/form-data"  onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="col-md-3 col-sm-6 col-xs-6 form-group">
                                        <label className="control-label">Organization: <span>*</span></label>
                                        <select className="form-control form-select" name="organization" id="organization" required  
                                            onChange={handleChange} >
                                            <option value="">Select Organization</option>
                                            {orgs && orgs.map((org, i) => (
                                                <option key={i} value={org._id}>{org.name}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-md-3 col-sm-6 col-xs-6 form-group">
                                        <label className="control-label">First Name: <span>*</span></label>
                                        <input name="first_name"  type="text" placeholder="First Name" className="form-control" required 
                                        onChange={handleChange} disabled={!state.organization} />
                                    </div>
                                    <div className="col-md-3 col-sm-6 col-xs-6 form-group">
                                        <label className="control-label">Last Name: <span>*</span></label>
                                        <input name="last_name"  type="text" placeholder="Last Name" className="form-control" required  
                                        onChange={handleChange} disabled={!state.organization}  />
                                    </div>
                                    <div className="col-md-3 col-sm-6 col-xs-6 form-group">
                                        <label className="control-label">Email Address: <span>*</span></label>
                                        <input name="email" type="email" placeholder="Email" className="form-control" required  
                                        onChange={handleChange} disabled={!state.organization}  />
                                    </div>
                                    <div className="col-md-3 col-sm-6 col-xs-6 form-group">
                                        <label className="control-label">Phone Number: <span>*</span></label>
                                        <input type="tel" maxLength='11' placeholder="Phone Number" className="form-control" name="phone" required  
                                        onChange={handleChange} disabled={!state.organization}  />
                                    </div>
                                    <div className="col-md-3 col-sm-6 col-xs-6 form-group">
                                        <label className="control-label">Gender: <span>*</span></label>
                                        <select className="form-control form-select" name="gender" id="gender" required  
                                        onChange={handleChange}  disabled={!state.organization} >
                                            <option value=''>Select Gender</option>
                                            <option value='male'>Male</option>
                                            <option value='female'>Female</option>
                                        </select>
                                    </div>
                                    <div className="col-md-3 col-sm-6 col-xs-6 form-group">
                                        <label className="control-label">Staff ID: <span>*</span></label>
                                        <input name="staff_id" type="text" placeholder="Staff ID" className="form-control" required  
                                        onChange={handleChange} disabled={!state.organization} />
                                    </div>
                                    <div className="col-md-3 col-sm-6 col-xs-6 form-group">
                                        <label className="control-label">Hire Year: <span>*</span></label>
                                        <select className="form-control form-select" name="hire_year" id="hire_year" required 
                                        onChange={handleChange} disabled={!state.organization}>
                                            <option value=''>Select Year</option>
                                            <option value="2020">2020</option>
                                            <option value="2021">2021</option>
                                            <option value="2022">2022</option>
                                            <option value="2023">2023</option>
                                            <option value="2024">2024</option>
                                        </select>
                                    </div>
                                    <div className="col-md-3 col-sm-6 col-xs-6 form-group">
                                        <label className="control-label">Hire Month: <span>*</span></label>
                                        <select className="form-control form-select" name="hire_month" id="hire_month" required 
                                        onChange={handleChange} disabled={!state.organization}>
                                            <option value=''>Select Month</option>
                                            {months && months.map((item, i) => (
                                                <option key={i} value={item.month}>{item.month}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-md-3 col-sm-6 col-xs-6 form-group">
                                        <label className="control-label">Hire Date: <span>*</span></label>
                                        <select className="form-control form-select" name="hire_date" id="hire_date" required 
                                        onChange={handleChange} disabled={!state.organization} 
                                        defaultValue={state.hire_date && state.hire_date} >
                                            <option value=''>Select Date</option>
                                            <option value="1">1</option>
                                            <option value="2">2</option>
                                            <option value="3">3</option>
                                            <option value="4">4</option>
                                            <option value="5">5</option>
                                            <option value="6">6</option>
                                            <option value="7">7</option>
                                            <option value="8">8</option>
                                            <option value="9">9</option>
                                            <option value="10">10</option>
                                            <option value="11">11</option>
                                            <option value="12">12</option>
                                            <option value="13">13</option>
                                            <option value="14">14</option>
                                            <option value="15">15</option>
                                            <option value="16">16</option>
                                            <option value="17">17</option>
                                            <option value="18">18</option>
                                            <option value="19">19</option>
                                            <option value="20">20</option>
                                            <option value="21">21</option>
                                            <option value="22">22</option>
                                            <option value="23">23</option>
                                            <option value="24">24</option>
                                            <option value="25">25</option>
                                            <option value="26">26</option>
                                            <option value="27">27</option>
                                            <option value="28">28</option>
                                            <option value="29">29</option>
                                            <option value="30">30</option>
                                            <option value="31">31</option>
                                        </select>
                                    </div>
                                    <div className="col-md-3 col-sm-6 col-xs-6 form-group">
                                        <label className="control-label">Job Role: <span>*</span></label>
                                        <select className="form-control form-select" name="job_role" id="job_role" required  
                                        onChange={handleChange}  disabled={!state.organization} >
                                            <option value=''>Select Job Role</option>
                                            {roles && roles.map((title, i) => (
                                                <option key={i} value={title._id}>{title.name}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-md-3 col-sm-6 col-xs-6 form-group">
                                        <label className="control-label">Department: <span>*</span></label>
                                        <select className="form-control form-select" name="department" id="department" required 
                                            onChange={handleChange}  disabled={!state.organization} >
                                            <option value=''>Select Department</option>
                                            {depts && depts.map((grade, i) => (
                                                <option key={i} value={grade._id}>{grade.name}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-md-3 col-sm-6 col-xs-6 form-group">
                                        <label className="control-label">Branch: <span>*</span></label>
                                        <select className="form-control form-select" name="branch" id="branch" required  
                                        onChange={handleChange} disabled={!state.organization}  >
                                            <option value=''>Select Branch</option>
                                            {branches && branches.map((team, i) => (
                                                <option key={i} value={team._id}>{team.branch_name}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                <div className="row form-group">
                                    <div className="col-md-12 col-sm-12">
                                        <button 
                                            type="submit" 
                                            disabled={loading} 
                                            className="btn btn-primary" 
                                        >
                                            CREATE EMPLOYEE ACCOUNT
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
